/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";

/**
 * Executes a callback everytime a click is detected outside of the `ref` element
 * @param ref Element to listen external clicks. Clicks inside this element will be ignored by this hook.
 * @param callback Action function.
 */
const useOutsideClick = (ref: any, callback: (...args: unknown[]) => void) => {
    const handleClick = (e: any) => {
        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    });
};

export default useOutsideClick;